import { postprocessTypographyTokens } from '../../utilities/postprocess-typography-tokens';

const defaultFontSize = '21px';
export const defaultLineHeight = 1.33;
export const defaultLetterSpacing = '-0.006em';

let typographyTokens: any = {
  '300': {
    fontSize: '14px',
  },
  '500': {
    fontSize: defaultFontSize,
  },
  '600': {
    fontSize: '24px',
  },
  '800': {
    fontSize: '36px',
  },
};

typographyTokens = postprocessTypographyTokens(typographyTokens);

export default typographyTokens;
